
import Vue, { PropType } from 'vue'
import CustomTextModal from './CustomTextModal.vue'

import { RSelect, RInput, RButton } from '@/components/'

import {
  SelectableResolutionOption,
  SelectableContainerAndCodecOption,
  TranscodeOptions,
} from '@/store/types/transcoding'

type TranscodeOptionsData = {
  chosenResolution?: SelectableResolutionOption | null
  chosenContainerAndCodec?: SelectableContainerAndCodecOption | null
  overlayText: string
}

export default Vue.extend({
  name: 'TranscodeOptionsModal',
  components: {
    CustomTextModal,
    RSelect,
    RInput,
    RButton,
  },
  props: {
    fileName: {
      type: String,
    },
    pending: {
      type: Boolean,
    },
    resolutionOptions: {
      type: Array as PropType<SelectableResolutionOption[]>,
    },
    containerAndCodecOptions: {
      type: Array as PropType<SelectableContainerAndCodecOption[]>,
    },
  },
  data(): TranscodeOptionsData {
    return {
      chosenResolution: null,
      chosenContainerAndCodec: null,
      overlayText: '',
    }
  },
  computed: {
    optionsPicked(): boolean {
      return !!this.chosenResolution && !!this.chosenContainerAndCodec
    },
  },
  methods: {
    handleConfirm(): undefined {
      if (!this.chosenResolution || !this.chosenContainerAndCodec) return

      const {
        chosenResolution: { width, height },
        chosenContainerAndCodec: { container, codec },
        overlayText: text,
      } = this

      // Perhaps it is too much that this is aware of the api-expected shape, but perhaps not?
      let transcodeOptions: TranscodeOptions = {
        resolution: { width, height },
        container,
        codec,
      }

      if (text) {
        transcodeOptions = {
          ...transcodeOptions,
          overlay: { text },
        }
      }

      this.$emit('confirm-transcode', transcodeOptions)
      return
    },
  },
})
